import { IApplicationState } from '../../../common/types/redux';

export function selectDetailsVisiblePrecision(state: IApplicationState) {
  return state.map.detailsVisiblePrecision;
}
